<template>
  <div>
    <div class="tab-box">
      <div class="tab-box-innder">
        <div
          v-for="(item, index) in data"
          :key="index"
          class="tab-box-item"
          :class="{ active: item.value === targeIndex }"
          @click="tabClick(index, item, true)"
        >
          {{ item.label }}
        </div>
      </div>

      <div ref="slider" class="tab-box-slider"></div>
    </div>
    <div class="tab-box-m-btn" :class="{ open: isOpen }" @click="open">
      <img
        @click.prevent
        class="tab-box-img down"
        src="https://azure-upms.obs.cn-south-1.myhuaweicloud.com/hycan-huaweicloud/backendUpload/20210609172654759-icon_common_arrows_24_dow_black@3x.png"
      />
      <div class="tab-box-m-list-outer" :style="{ height, opacity }">
        <div class="tab-box-m-list" ref="inner" @click.stop="false">
          <div
            v-for="(item, index) in data"
            :key="index"
            class="tab-box-m-item"
            :class="{ active: item.value === targeIndex }"
            @click="tabClick(index, item, false, true)"
          >
            {{ item.label }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Tab",
  props: ["data", "defaultValue"],
  data() {
    return {
      targeIndex: 0,
      isOpen: false,
      height: 0,
      opacity: 0,
    };
  },
  computed: {},
  watch: {
    data() {
      this.$nextTick(() => {
        this.doAni(this.targeIndex, true);
      });
    },
  },
  created() {
    this.targeIndex = this.defaultValue || this.data[0].value;
  },
  mounted() {
    this.doAni(0, true);
  },
  methods: {
    open() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        console.log(this.$refs.inner.clientHeight);
        this.height = this.$refs.inner.clientHeight + "px";
        this.opacity = 1;
      } else {
        this.opacity = 0;
        this.height = 0;
      }
    },
    doAni(index, noAni) {
      let el = document.querySelectorAll(".tab-box-item")[index];
      if (!el) return;
      let left = el.offsetLeft;
      let { slider } = this.$refs;
      let aniText =
        "transition: transform 260ms cubic-bezier(0.33, 1, 0.68, 1);";
      if (noAni) {
        aniText = "";
      }
      slider.style.cssText = `transform:translateX(${left}px);${aniText}`;
    },
    tabClick(index, item, ani, close) {
      this.targeIndex = item.value;
      this.$emit("change", index, item);
      ani && this.doAni(index);
      close && this.open();
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@style/base";

.tab-box {
  position: relative;
  border-radius: 4px;
  overflow: hidden;
  @include media(
    (
      $sm: (
        display: none,
      ),
    )
  );
  @include setThemeClass {
    .tab-box-slider {
      position: absolute;
      z-index: 1;
      left: -1px;
      top: -1px;
      bottom: -1px;
      width: 104px;
      background-color: getThemeVal(brandColorBlack);
    }
    .tab-box-innder {
      display: flex;
      align-items: center;
      justify-content: center;
      border-radius: 4px;
      border: 1px solid #131415;

      .tab-box-item {
        position: relative;
        width: 102px;
        box-sizing: border-box;
        height: 36px;
        line-height: 36px;
        text-align: center;
        cursor: pointer;
        z-index: 2;
        &.active {
          color: getThemeVal(brandColorWhite);
        }
      }
      .tab-box-item + .tab-box-item::after {
        content: "";
        position: absolute;
        left: 0;
        top: 50%;
        width: 1px;
        height: 11px;
        transform: translate3D(0, -50%, 0);
        background-color: getThemeVal(brandColorBlack);
      }
    }
  }
}
@include setThemeClass {
  .tab-box-m-btn {
    position: relative;
    display: none;
    width: 40px;
    height: 40px;
    background-color: getThemeVal(brandColorWhite);
    border: 1px solid getThemeVal(navColorBlack);
    @include media(
      (
        $sm: (
          display: block,
        ),
      )
    );
    .tab-box-img {
      position: absolute;
      top: 50%;
      left: 50%;
      margin-left: -9px;
      margin-top: -9px;
      z-index: 1;
      width: 18px;
      height: 18px;
      transition: all 200ms $easeOutCubic;
    }
    .tab-box-m-list-outer {
      position: absolute;
      right: 0;
      margin-top: 1px;
      top: 100%;
      overflow: hidden;
      transition: all 300ms $easeOutCubic;
      box-shadow: 0 0 7px 1px getThemeVal(brandColorBlackOpacity3);
      @include media(
        (
          $sm: (
            display: block,
          ),
        )
      );
    }
    .tab-box-m-list {
      background-color: getThemeVal(brandColorWhite);
    }
    .tab-box-m-item {
      cursor: pointer;
      width: 100px;
      height: 50px;
      line-height: 50px;
      text-align: center;
      font-size: 14px;
      color: getThemeVal(brandColorBlack);
      & + .tab-box-m-item {
        border-top: 1px solid getThemeVal(backgroundColorGray);
      }
    }
    &.open {
      .tab-box-img {
        transform: rotate(180deg);
      }
      .tab-box-m-list-outer {
        visibility: visible;
      }
    }
  }
}
</style>
